import logger from '@/utils/logger'

const LOG = logger('utils request')
const VERSION = 2.0
const storeKey = 'header'
const userKey = 'db:user'
const versionKey = 'db:version'

// helper to retrieve store - setting as constant fails tests
const getStore = () => window.localStorage

// helper for storing and retrieving cached items
export const retrieveItem = (key) => {
  try {
    return JSON.parse(getStore().getItem(key))
  } catch {
    return {}
  }
}
const storeItem = (key, value) => getStore().setItem(key, JSON.stringify(value))

// helpers for dealing with cached user
export const setStoredUser = (user) => storeItem(userKey, user)
export const getStoredUser = () => retrieveItem(userKey)

export const checkLocalStore = (user) => {
  LOG.debug('Checking localStorage')
  const storedVersion = retrieveItem(versionKey)
  const store = getStore()

  // if the user or its client or organisation has changed - we need to trash vuex
  const storedUser = retrieveItem(userKey)
  const checkKeys = ['subject', 'active_client']
  if (!storedUser || checkKeys.some(key => storedUser[key] !== user[key])) {
    LOG.debug('Stored user changed - deleting localStorage')
    store.removeItem(storeKey)
  } else {
    const diffEntities = storedUser.entities.filter(x => user.entities.includes(x))
    if (diffEntities.length) {
      LOG.debug('Stored user entities changed - deleting localStorage')
      store.removeItem(storeKey)
    }
  }
  setStoredUser(user)

  const vuexStored = retrieveItem(storeKey)
  LOG.debug(`localStorage version: ${VERSION}`)

  // version is good, exit
  if (storedVersion === VERSION) return

  // no version stored
  if (vuexStored && 'header' in vuexStored && !storedVersion) {
    // delete stored filters as we did not have localStorage versioning prior
    // and it is impossible to work out what state the filters are in right now
    LOG.debug(`no version: deleting store`)
    store.removeItem(storeKey)
  }

  // // NOTE: In the future we can add store version transitions here
  // else if ( storedVersion === 1 ) {
  //
  // }

  // store version
  LOG.debug(`localStorage updated to: ${VERSION}`)
  storeItem(versionKey, VERSION)
}
